import { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import cx from 'classnames';

import styles from './NodeTypes.module.css';
//  import useNodeClickHandler from '../../../hooks/useNodeClick';
import { numberFormatter } from '../../../utils/numberFormatter';
import { MinusSquare, PlusSquare } from '../../assets';

const WorkflowNode = ({ id, data }: NodeProps) => {
  // see the hook implementation for details of the click handler
  // calling onClick adds a child node to this node
  //  const onClick = useNodeClickHandler(id);
  const isExpanded = data?.nodes?.length > 0;
  return (
    <div
      //  onClick={onClick}
      className={`${cx(styles.node)} flex flex-row justify-between items-center`}
      title="click to add a child node"
    >
      <div className="flex flex-col items-start">
        <p className='text-left'>{data?.name}</p>
        <div className="flex">
          <p className="text-sm">{numberFormatter(data?.supportedRevenue)}</p>
          {
            (data?.percentage || data?.percentage === 0) && (
              <>
                <p className="text-sm mx-2"> | </p>
                <p className="text-sm">{data?.percentage}%</p>
              </>
            )
          }
        </div>
      </div>
      <div>
        {
          isExpanded ? (
            <MinusSquare />
          ) : (
            <PlusSquare />
          )
        }
      </div>
      <Handle
        className={styles.handle}
        type="target"
        position={Position.Top}
        isConnectable={false}
      />
      <Handle
        className={styles.handle}
        type="source"
        position={Position.Bottom}
        isConnectable={false}
      />
    </div>
  );
};

export default memo(WorkflowNode);
